export default "__VITE_ASSET__CVOw_Xek__"